import { Banner, Typography } from '@capsule/consumer-design-system';

import styled from 'styled-components';

export const OpenChat = styled.a`
  && {
    color: ${({ theme }) => theme.colors.capsuleGreen60};
    cursor: pointer;

    &:hover {
      color: ${({ theme }) => theme.colors.capsuleGreen80};
      text-decoration: underline;
    }
  }
`;

export const SubTitle = styled(Typography).attrs({
  variant: 'body',
})`
  margin-bottom: ${({ theme }) => theme.space.s5};
  color: ${({ theme }) => theme.colors.capsuleBlue50};
`;

export const ErrorBanner = styled(Banner)`
  opacity: 0.85;
  background-color: ${({ theme }) => theme.colors.capsuleRed60};
  margin-bottom: ${({ theme }) => theme.space.s5};
`;
